import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '../layouts/layout/layout.component';
import { LoginAuthenticationGuardService } from 'src/app/auth/guards/login-authentication-guard.service';
import { VeriskAuthGuard } from 'src/app/auth/guards/verisk-auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate:[LoginAuthenticationGuardService],
    children:[
      {
        path:'utilization',
        loadChildren: () => import('../pages/utilization/utilization.module').then(m => m.UtilizationModule)
      },
      {
        path: 'profile-setting',
        loadChildren: () => import('../pages/manage-user/profile/profile-settings/profile-settings.module').then(m => m.ProfileSettingsModule)
      },
      {
        path: 'history/:TypeNameId/:type',
        loadChildren: () => import('../pages/history-master/history-master.module').then(m => m.HistoryMasterModule)
      },
      {
        path: 'revocation',
        loadChildren: () => import('../pages/revocation/revocation.module').then(m => m.RevocationModule)
      },
      {
        path: 'requests',
        canActivate: [VeriskAuthGuard],
        loadChildren: () => import('../pages/claims-monitoring/claims-monitoring.module').then(m => m.ClaimsMonitoringModule)
      },
      {
        path: 'requests/request-details',
        loadChildren: () => import('../pages/claims-monitoring/claim-review-detail/claim-review-detail.module').then(m => m.ClaimReviewDetailModule)
      },
      {
        path: 'workbench',
        loadChildren: () => import('../pages/claims-modification/claims-modification.module').then(m => m.ClaimsModificationModule)
      },
      {
        path: 'workbench/workbench-details',
        loadChildren: () => import('../pages/claims-modification/claim-preview-detail/claim-preview-detail.module').then(m => m.ClaimPreviewDetailModule)
      },
      {
        path: 'staff',
        loadChildren: () => import('../pages/report-reviewer/report-reviewer.module').then(m => m.ReportReviewerModule)
      },
      {
        path: 'invoices',
        loadChildren: () => import('../pages/payment-profile/payment-profile.module').then(m => m.PaymentProfileModule)
      },
      {
        path:'clients',
        loadChildren: () => import('../pages/manage-client/clients/clients.module').then(m => m.ClientsModule)
      },
      {
        path: 'client/expiration',
        loadChildren: () => import('../pages/client-expiration/client-expiration-routing.module').then(m => m.ClientExpirationRoutingModule)
      },
      {
        path: 'client/addclient/:clientId',
        loadChildren: () => import('../pages/manage-client/addclient/addclient.module').then(m => m.AddclientModule)
      },
      {
        path: 'client/viewclient/:clientId',
        loadChildren: () => import('../pages/manage-client/viewclient/viewclient.module').then(m => m.ViewclientModule)
      },
      {
        path: 'user/adduser',
        loadChildren: () => import('../pages/manage-user/adduser/adduser.module').then(m => m.AdduserModule)
      },
      {
        path: 'team/addteam',
        loadChildren: () => import('../pages/teams/addteams/addteams.module').then(m => m.AddteamsModule)
      },
      {
        path: 'parameters',
        loadChildren: () => import('../pages/parameters/parameters.module').then(m => m.ParametersModule)
      },
      {
        path:'user/loginhistory/:userId',
        loadChildren: () => import('../pages/manage-user/user-login-history/user-login-history.module').then(m=> m.UserLoginHistoryModule)
     },
     {
      path: 'history',
      loadChildren: () => import('../pages/history-master/history-master.module').then(m => m.HistoryMasterModule)
    },
    {
      path: 'feedback',
      loadChildren: () => import('../pages/feedback/getfeedbacklist/getfeedbacklist.module').then(m => m.GetfeedbacklistModule)
    },
    {
      path: 'media-forensics',
      loadChildren: () => import('../pages/media-forensics/media-forensics.module').then(m => m.MediaForensicsModule)
    },
    // Gated by LINKOUT_FEATURE_ENABLED in linkout-feature.config.ts (guard redirects /linkout → /requests when off).
    {
      path: 'linkout',
      loadChildren: () => import('../pages/linkout/linkout.module').then(m => m.LinkoutModule)
    },
    {
      path: '**',
      pathMatch: 'full',
      redirectTo: 'utilization',
    }
    ]
  },
];

@NgModule({
  declarations:[],
  imports: [
    RouterModule.forRoot(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class ApplicationRoutingModule { }
